import {RemoteBase, RemoteEndpoint_Impl_, ResponseReader_Impl_} from "./Remote"
import {Single} from "../../streams/Stream"
import {Parser14} from "../../json/Parser14"
import {HeaderField, HeaderValue_Impl_} from "../../http/Header"
import {LazyConst} from "../../core/Lazy"
import {ByteChunk} from "../../chunk/ByteChunk"
import {Bytes} from "../../../haxe/io/Bytes"
import {Register} from "../../../genes/Register"

export const Remote17 = Register.global("$hxClasses")["tink.web.proxy.Remote17"] = 
class Remote17 extends Register.inherits(RemoteBase) {
	new(client, endpoint) {
		super.new(client, endpoint);
	}
	auth() {
		let __body__ = "";
		let this1 = "auth";
		return RemoteEndpoint_Impl_.request(RemoteEndpoint_Impl_.sub(this.endpoint, {"path": [this1], "query": [], "headers": [new HeaderField("content-length", HeaderValue_Impl_.ofInt(ByteChunk.of(Bytes.ofString(__body__)).getLength())), new HeaderField("accept", "application/json")].concat([])}), this.client, "GET", new Single(new LazyConst(ByteChunk.of(Bytes.ofString(__body__)))), ResponseReader_Impl_.ofStringReader((o=>Register.bind(o, o.tryParse))(new Parser14())));
	}
	static get __name__() {
		return "tink.web.proxy.Remote17"
	}
	static get __super__() {
		return RemoteBase
	}
	get __class__() {
		return Remote17
	}
}

